export type VizSnapshot = {
  modal: unknown;
  raytrace: unknown;
  volume: unknown;
  velocity?: unknown;
};

export function createVizDesignCache() {
  const store = new Map<string, VizSnapshot>();

  return {
    stash(id: string, snap: VizSnapshot): void {
      store.set(id, structuredClone(snap));
    },
    take(id: string): VizSnapshot | undefined {
      return store.get(id);
    },
  };
}
